import { render, staticRenderFns } from "./list.vue?vue&type=template&id=3d7bd83b&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=3d7bd83b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7bd83b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d7bd83b')) {
      api.createRecord('3d7bd83b', component.options)
    } else {
      api.reload('3d7bd83b', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=3d7bd83b&scoped=true&", function () {
      api.rerender('3d7bd83b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/collection-list/list.vue"
export default component.exports